"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "small-theme": "small-theme_UoetTn",
  "smallTheme": "small-theme_UoetTn",
  "label": "label_2W_tR4",
  "container": "container_1Xpe7V",
  "bar-container": "bar-container_lLXRsw",
  "barContainer": "bar-container_lLXRsw",
  "bar": "bar_2DTXZG",
  "full-bar": "full-bar_1jXZ-1",
  "fullBar": "full-bar_1jXZ-1"
}; 
require('./ProgressBar.css');
/**
 * Converts the number passed by parameter into a percentage, if it is a value less than 1 percent, the
 * number will be presented with a precision of 2 decimal places.
 */
var convertToPercentageString = function convertToPercentageString(percentage) {
  var roundedPercentage = Math.round(percentage);
  if (percentage > 0 && roundedPercentage === 0) {
    return "".concat(percentage.toPrecision(2), "%");
  }
  return "".concat(roundedPercentage, "%");
};
var calculateScale = function calculateScale(value, maxValue, isPercentage) {
  if (!maxValue) {
    return 0;
  }
  var usedValue = isPercentage ? Math.round(value) : value;
  var scale = usedValue / maxValue;
  var roundedScale = Math.round(scale);
  if (roundedScale === 0 && value > 0) {
    return 1;
  }
  return roundedScale;
};
var ProgressBar = function ProgressBar(_ref) {
  var testId = _ref.testId,
    maxValue = _ref.maxValue,
    value = _ref.value,
    denominatorValue = _ref.denominatorValue,
    color = _ref.color,
    label = _ref.label,
    smallTheme = _ref.smallTheme,
    isPercentage = _ref.isPercentage;
  var showAsPercentage = isPercentage && !!denominatorValue;
  var usedValue = value !== null && value !== void 0 ? value : 0;
  var percentageValue = usedValue * 100;
  var progress = calculateScale(percentageValue, maxValue, showAsPercentage);
  var containerStyle = React.useMemo(function () {
    return {
      backgroundColor: "".concat(color, "30")
    };
  }, [color]);
  var barStyle = React.useMemo(function () {
    return {
      width: "".concat(progress, "%"),
      backgroundColor: color
    };
  }, [progress, color]);
  return /*#__PURE__*/React.createElement("div", {
    "data-test-id": testId,
    className: smallTheme ? styles.smallTheme : undefined
  }, /*#__PURE__*/React.createElement("span", {
    "data-test-id": "".concat(testId, "-label"),
    className: (0, _classnames.default)(styles.label, {
      'visually-hidden': !smallTheme
    })
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, "(It represents the ", progress, " percent of ", label.toLowerCase(), " highest value)"), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("span", {
    "data-test-id": "".concat(testId, "-value")
  }, showAsPercentage ? convertToPercentageString(percentageValue / denominatorValue) : usedValue), /*#__PURE__*/React.createElement("div", {
    "data-test-id": "".concat(testId, "-progress-bar-container"),
    className: styles.barContainer,
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    "data-test-id": "".concat(testId, "-progress-bar-filled"),
    className: progress < 100 ? styles.bar : styles.fullBar,
    style: barStyle
  }))));
};
ProgressBar.defaultProps = {
  testId: 'progress-bar',
  smallTheme: false,
  isPercentage: false
};
var _default = exports.default = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map